import gettext, { pgettext } from '@sdk/lang/gettext';
import { Feature } from '@sdk/common/features';
import { useSession } from '@sdk/session/SessionContext';
import useModalState from '@sdk/components/ui/modal/useModalState';
import { useEffect } from 'react';

import lockedConversationImage from '@web/assets/images/premium-features/group-messages-locked.png';
import CrownSvg from '@web/assets/svg/UI/crown.svg';
import { Button, Subtitle, Title } from '@web/premiumGuard/featurePreview/featurePreview.styles';
import PremiumGuard from '@web/premiumGuard/PremiumGuard';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';
import { useGroupConversationsPremiumGuard } from '@web/conversations/hooks/useGroupConversationsPremiumGuard';
import { ToastBillingPlansModal } from '@web/account/components/ToastBillingPlansModal/ToastBillingPlansModal';

import { Wrapper, Description, ImageWrapper } from './conversationLocked.styles';

export const ConversationLocked = () => {
  const { premiumGuardConfig } = useGroupConversationsPremiumGuard();
  const { currentUser } = useSession();
  const { isToastBilling } = currentUser.org;
  const { isVisible, open, close } = useModalState();

  return (
    <Wrapper>
      <ImageWrapper>
        <img src={lockedConversationImage} />
      </ImageWrapper>
      <Title>{pgettext('feature title', 'Send group messages')}</Title>
      <Subtitle>
        <CrownSvg aria-hidden={true} />{' '}
        {gettext('Available in %(requiredPlan)s', {
          requiredPlan: premiumGuardConfig.requiredPlan,
        })}
      </Subtitle>

      <Description>
        {gettext(
          'Send messages to multiple people at once, easily reach groups, locations or specific positions, communicate more efficiently, and build a better company culture!'
        )}
      </Description>

      {!isToastBilling && (
        <PremiumGuard
          hasAccess={false}
          premiumFeature={Feature.groupMessages}
          premiumGuardModalName={PremiumModalNames.groupMessages}>
          <Button inactive>{gettext('Learn more >')}</Button>
        </PremiumGuard>
      )}

      {isToastBilling && <Button onClick={open}>{gettext('Learn more >')}</Button>}
      {isVisible && <ToastBillingPlansModal dismiss={close} />}
    </Wrapper>
  );
};
